var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD267",
    fillRule: "evenodd",
    d: "m7.555.681 1.214 3.29a.73.73 0 0 0 .638.485l3.368.19c.664.037.935.91.419 1.347l-2.618 2.224a.78.78 0 0 0-.244.784l.868 3.408c.171.67-.538 1.21-1.096.832l-2.831-1.916a.7.7 0 0 0-.79 0l-2.83 1.916c-.559.378-1.268-.161-1.097-.832L3.424 9a.78.78 0 0 0-.244-.784L.562 5.993c-.516-.438-.245-1.31.419-1.347l3.368-.19a.73.73 0 0 0 .638-.485L6.201.681a.715.715 0 0 1 1.354 0"
  })));
};
export default SvgStar;